import { css, cx } from "@emotion/css";
import { EqualsIcon } from "@octopusdeploy/design-system-icons";
import { space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import React from "react";
import { accessibilityStyles } from "../../utils";
import { resetStyles } from "../../utils/resetStyles";
import { Tooltip } from "../Tooltip";
import { ProcessOverviewStep } from "./ProcessOverviewStep";
import type { ProcessOverviewStepData } from "./types";
export type ProcessOverviewRootStep = ProcessOverviewStepData & {
    stepNumber: number;
    isRunInParallelWithPreviousStep: boolean;
};
export interface ProcessOverviewProps {
    steps: ProcessOverviewRootStep[];
    showNote: boolean;
}
export function ProcessOverview({ steps, showNote }: ProcessOverviewProps) {
    return (<ol className={styles.root}>
            {steps.map((step) => (<li key={step.id} className={styles.stepListItem}>
                    <div className={cx(styles.stepNumber, { [styles.containerStepNumber]: isStepContainer(step) })}>
                        <span className={styles.stepAccessibilityPrefix}>Step&nbsp;</span>
                        {step.stepNumber}
                    </div>
                    {step.stepNumber !== 1 && step.isRunInParallelWithPreviousStep && <RunInParallelIcon />}
                    <ProcessOverviewStep stepData={step} showNote={showNote}/>
                </li>))}
        </ol>);
}
function RunInParallelIcon() {
    return (<div className={styles.parallelIcon}>
            <Tooltip content={"Runs in parallel"}>
                <EqualsIcon size={16} color={themeTokens.color.parallelChip.icon}/>
            </Tooltip>
        </div>);
}
function isStepContainer(step: ProcessOverviewStepData): boolean {
    return "containerType" in step;
}
const styles = {
    root: css({
        ...resetStyles.list,
        display: "flex",
        flexDirection: "column",
        gap: space[8],
        maxWidth: "60rem",
    }),
    stepListItem: css({
        position: "relative",
        display: "flex",
        gap: space[12],
    }),
    stepNumber: css({
        font: text.body.regular.xSmall,
        color: themeTokens.color.text.secondary,
        padding: `${space[12]} 0`,
    }),
    stepAccessibilityPrefix: css({
        ...accessibilityStyles.hidden,
    }),
    containerStepNumber: css({
        padding: `${space[16]} 0`,
    }),
    parallelIcon: css({
        position: "absolute",
        top: "-0.875rem",
        left: "0.75rem",
        borderRadius: "50%",
        width: "20px",
        height: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: themeTokens.color.parallelChip.background,
    }),
};
